import {
  Button,
  Datepicker,
  TextArea,
  Accordion,
  AccordionTab,
  Autocomplete,
  Radio,
  RadioGroup,
  Icon,
} from '@a-ui/react';
import { useDispatch, useSelector } from 'react-redux'
import PickerWrapper from '../../PickerWrapper/PickerWrapper'
import { closeModal } from '../../../store/slices/modalReducer'
import { startOfdayMinuteOffset, isoWithoutZone } from '../../../helpers/dateTime.helper';
import { getDomains, getTaskTypesForDomain } from '../../../store/slices/domainsReducer'
import { createTask, claimTask, resetCreateLoading } from '../../../store/slices/tasksReducer'
import Spinner from '../../Spinner/Spinner';
import { useState, useEffect } from 'react';

const CreateTask = (props) => {
  const dispatch = useDispatch();
  const { domains, taskTypes } = useSelector(state => state.domains);
  const { createLoading } = useSelector(state => state.tasks);
  const [ domain, setDomain ] = useState(false);
  const [ claim, setClaim ] = useState('false');
  const [ location, setLocation ] = useState({});
  const [ plannedDueDate, setPlannedDueDate ] = useState(null);
  const [ plannedDueTime, setPlannedDueTime ] = useState(null);
  const [ plannedEndDate, setPlannedEndDate ] = useState(null);
  const [ plannedEndTime, setPlannedEndTime ] = useState(null);
  const [ plannedStartDate, setPlannedStartDate ] = useState(null);
  const [ plannedStartTime, setPlannedStartTime ] = useState(null);

  const [ form, setFormData ]  = useState({
    preconditions: "",
    priority: "",
    taskType: "",
    description: "",
    publicationDate: isoWithoutZone(startOfdayMinuteOffset(new Date(), 30)),
    formAndSurveyData: {
      "templateId": "",
      "responseId": "",
      "responseJson": ""
    },
    dueDate: null,
    dueTime: null,
    "referenceUrl": "",
    "actualLocation": {
      "xCoordinate": "",
      "streetNumber": "",
      "yCoordinate": "",
      "friendlyName": "",
      "street": "",
      "postalCode": ""
    },
    "location": {
      "xCoordinate": "",
      "streetNumber": "",
      "yCoordinate": "",
      "friendlyName": "",
      "street": "",
      "postalCode":""
    },
    "status": "",
    "plannedStartDate": null,
    "plannedStartTime": null,
    "plannedEndDate": null,
    "plannedEndTime": null,
    domain: "",
    name: ""
  });

  const [ nameValid, setNameValid ]  = useState(true);
  const [ domainValid, setDomainValid ]  = useState(true);
  const [ descriptionValid, setDescriptionValid ]  = useState(true);
  const [ taskTypeValid, setTaskTypeValid ]  = useState(true);

  const getTimestamp = (date, time) => {
    // const d = date.split("/");
    // const dateString = `${d[2]}-${d[1]}-${d[0]}`;
    const [dateString] = date.split("T");
    const timeString = time ? time : "00:30";
    const datestamp = new Date(`${dateString}T${timeString}:00`);
    return isoWithoutZone(startOfdayMinuteOffset(new Date(datestamp)));
  }

  useEffect(() => {
    dispatch(getDomains());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(domain) {
      const selectedDomain = domains.find(({name}) => (name === domain))
      dispatch(getTaskTypesForDomain(selectedDomain.id));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domain]);

  // duedate
  useEffect(() => {
    let newFormObject = { ...form };
    if (plannedDueDate) {
      newFormObject['dueDate'] = getTimestamp(plannedDueDate, plannedDueTime);
      newFormObject['dueTime'] = plannedDueTime ? plannedDueTime : null;
    } else {
      newFormObject['dueDate'] = null;
      newFormObject['dueTime'] = null;
    }
    setFormData(newFormObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plannedDueDate, plannedDueTime]);

  // location
  useEffect(() => {
    let newFormObject = { ...form };
    if(location === {}) {
      newFormObject['location'] = {
        "xCoordinate": "",
        "streetNumber": "",
        "yCoordinate": "",
        "friendlyName": "",
        "street": "",
      };
    // locationpicker drop pin
    } else if(location.actualLocation) {
      newFormObject['location'] = {
        "xCoordinate": location.actualLocation?.lat,
        "yCoordinate": location.actualLocation?.lng,
        "streetNumber": location.address?.houseNumber?.houseNumber,
        "friendlyName": location.address?.formattedAddress || location.label,
        "street": location.address?.street?.streetName,
        "postalCode": location.address?.municipality?.postCode
      };
    // locationpicker put in name
    } else if(location.position) {
      newFormObject['location'] = {
        "xCoordinate": location.position?.wgs84.lat,
        "yCoordinate": location.position?.wgs84.lng,
        "streetNumber": location.address?.houseNumber?.houseNumber,
        "friendlyName": location.address?.formattedAddress || location.name,
        "street": location.address?.street?.streetName,
        "postalCode": location.address?.municipality?.postCode
      };
    } else {
      newFormObject['location'] = {
        "xCoordinate": location.addressPosition?.wgs84.lat,
        "yCoordinate": location.addressPosition?.wgs84.lng,
        "streetNumber": location.houseNumber?.houseNumber,
        "friendlyName": location.formattedAddress,
        "street": location.street?.streetName,
        "postalCode": location.address?.municipality?.postCode
      };
    }
    setFormData(newFormObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  // enddate
  useEffect(() => {
    let newFormObject = { ...form };
    if (plannedEndDate) {
      newFormObject['plannedEndDate'] = getTimestamp(plannedEndDate, plannedEndTime);
      newFormObject['plannedEndTime'] = plannedEndTime ? plannedEndTime : null;
    } else {
      newFormObject['plannedEndDate'] = null;
      newFormObject['plannedEndTime'] = null;
    }
    setFormData(newFormObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plannedEndDate, plannedEndTime]);

  // startdate
  useEffect(() => {
    let newFormObject = { ...form };
    if (plannedStartDate) {
      newFormObject['plannedStartDate'] = getTimestamp(plannedStartDate, plannedStartTime);
      newFormObject['plannedStartTime'] = plannedStartTime ? plannedStartTime : null;
;
    } else {
      newFormObject['plannedStartDate'] = null;
      newFormObject['plannedStartTime'] = null;
    }
    setFormData(newFormObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plannedStartDate, plannedStartTime]);

  const domainOptions = domains.map((domain) => ({ label: domain.name, value: domain.name }));
  const domainTasktypeOptions = taskTypes.map((taskType) => ({ label: taskType.taskType, value: taskType.taskType}));

  const updateFilter = (e) => {
    let newFormObject = { ...form };
    const { name, value } = e.target;
    if (name === "name") { (!!value && value !== '') ? setNameValid(true) : setNameValid(false) }
    if (name === "description") { (!!value && value !== '') ? setDescriptionValid(true) : setDescriptionValid(false) }
    if (name === "domain") { (!!value && value !== '') ? setDomainValid(true) : setDomainValid(false) }
    if (name === "taskType") { (!!value && value !== '') ? setTaskTypeValid(true) : setTaskTypeValid(false) }
    if (!value || value === "false") {
      delete newFormObject[name];
    } else {
      newFormObject[name] = value;
    }
    setFormData(newFormObject);
  }

  const submit = () => {
    let valid = true;
    if (form.name === '') {
      setNameValid(false);
      valid = false;
    }
    if (form.description === '') {
      setDescriptionValid(false);
      valid = false;
    }
    if (form.domain === '') {
      setDomainValid(false);
      valid = false;
    }
    if (form.taskType === '') {
      setTaskTypeValid(false);
      valid = false;
    }
    if(!valid) return;
    dispatch(createTask(form)).then(({payload}) => {
      if(payload.error) {
        dispatch(resetCreateLoading())
        return;
      }
      const { id } = payload;
      let createTaskPromise = Promise.resolve();
      if (claim === "true") {
        createTaskPromise = dispatch(claimTask(id))
      }
      createTaskPromise.then(() => {
        dispatch(closeModal());
      }).catch((e) => {
        console.error("something went wrong", e)
      });
    });
  }
  return <>
    <div className="row">
      <div className="col-xs-12 u-margin-bottom-xs">
        <div className="a-input">
          <label className="a-input__label u-margin-bottom-xs">Titel<span className="u-text-danger">*</span></label>
          {!nameValid && <small className="a-input__description is-error" id="text-field-error-description"><Icon className="u-no-margin-right"name="ai-alert-triangle"/>Naam is verplicht</small>}
          <input
            type="text"
            name="name"
            placeholder='Geef de titel van een taak in'
            value={form.name}
            required={true}
            onChange={updateFilter}
          />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12 u-margin-bottom-xs">
        <div className="a-input">
          <label className="a-input__label u-margin-bottom-xs">Omschrijving<span className="u-text-danger">*</span></label>
          {!descriptionValid && <small className="a-input__description is-error" id="text-field-error-description"><Icon className="u-no-margin-right"name="ai-alert-triangle"/>Omschrijving is verplicht</small>}
          <TextArea
            id={"textarea-1"}
            name={"description"}
            className={"textarea-class"}
            required={true}
            placeholder={"Give a description"}
            onChange={updateFilter} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12 u-margin-bottom-xs">
          <label className="a-input__label u-margin-bottom-xs">Domein<span className="u-text-danger">*</span></label>
          {!domainValid && <small className="a-input__description is-error" id="text-field-error-description"><Icon className="u-no-margin-right"name="ai-alert-triangle"/>Domein is verplicht</small>}
        <div className="a-input">
          { (domainOptions.length > 0) && <Autocomplete
            items={domainOptions.length > 0 ? domainOptions : [] }
            id="autocomplete-1"
            onChange={(selected) => {
              setDomain(selected);
              updateFilter({ target: {name: 'domain', value: selected}});
            }}
            required={true}
            placeholder="Selecteer domein">
          </Autocomplete> }
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12 u-margin-bottom-xs">
        <div className="a-input">
          <RadioGroup
            label={"Toegewezen persoon"}
            name={"radio-name"}
            value={claim}
            onChange={(e) => setClaim(e)}>
            <Radio
              id="me"
              label="Mezelf"
              value="true"
            />
            <Radio
              id="nobody"
              label="Niemand"
              value="false"
            />
          </RadioGroup>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12 u-margin-bottom-xs">
        <div className="a-input">
          { (domainTasktypeOptions.length > 0) && <>
          <label className="a-input__label u-margin-bottom-xs">Type taak<span className="u-text-danger">*</span></label>
            {!taskTypeValid && <small className="a-input__description is-error" id="text-field-error-description"><Icon className="u-no-margin-right"name="ai-alert-triangle"/>Type taak is verplicht</small>}
            <Autocomplete
            items={domainTasktypeOptions}
            id="autocomplete-1"
            onChange={(selected) => {
              updateFilter({ target: {name: 'taskType', value: selected}});
            }}
            required={true}
            placeholder="Selecteer een taak type">
          </Autocomplete>
          </>}
        </div>
      </div>
    </div>

    <Accordion>
      <AccordionTab header="Planning">
        <div className="u-margin">
         <div className="row">
           <div className="col-xs-8 u-margin-bottom-xs">
                <Datepicker
                  inputProps={{ label: "Start Datum" }}
                  format={"dd/MM/yyyy"}
                  mask={"99/99/9999"}
                  onChange={(date) => {
                    setPlannedStartDate(date);
                  }}
                />
           </div>
           <div className="col-xs-4 u-margin-bottom-xs">
                <div className="a-input"><label className="a-input__label" htmlFor="time-field">Tijdstip</label>
                  <div className="a-input__wrapper">
                    <input type="time" name="time-field" id="time-field" onChange={(e) => { setPlannedStartTime(e.target.value) }}/>
                  </div>
                </div>
           </div>
         </div>
         <div className="row">
           <div className="col-xs-8 u-margin-bottom-xs">
             <div className="a-input">
               <div className="a-input has-icon-right datepicker-top">
                 <div className="a-input__wrapper">
                   <div className="a-input">
                     <Datepicker
                       inputProps={{
                         label: "Geplande einddatum"
                       }}
                       format={"dd/MM/yyyy"}
                       mask={"99/99/9999"}
                       onChange={(date) => setPlannedEndDate(date)}
                     />
                   </div>
                 </div>
               </div>
             </div>
           </div>
           <div className="col-xs-4 u-margin-bottom-xs">
             <div className="a-input"><label className="a-input__label" htmlFor="time-field">Tijdstip</label>
               <div className="a-input__wrapper">
                 <input type="time" name="time-field" id="time-field" onChange={(e) => { setPlannedEndTime(e.target.value) }}/>
               </div>
             </div>
           </div>
         </div>
         <div className="row">
           <div className="col-xs-8 u-margin-bottom-xs">
             <div className="a-input">
               <div className="a-input has-icon-right datepicker-top">
                 <div className="a-input__wrapper">
                   <div className="a-input">
                     <Datepicker
                       inputProps={{
                         label: "Uiterste datum"
                       }}
                       format={"dd/MM/yyyy"}
                       mask={"99/99/9999"}
                       onChange={(date) => setPlannedDueDate(date)}
                     />
                   </div>
                 </div>
               </div>
             </div>
           </div>
           <div className="col-xs-4 u-margin-bottom-xs">
             <div className="a-input"><label className="a-input__label" htmlFor="time-field">Tijdstip</label>
               <div className="a-input__wrapper">
                 <input type="time" name="time-field" id="time-field" onChange={(e) => { setPlannedDueTime(e.target.value) }}/>
               </div>
             </div>
           </div>
         </div>
        </div>
      </AccordionTab>
      <AccordionTab header="Locatie">
        <div className="u-margin" style={{ 'width': "100%"}}>
          <div className="row">
            <div className="col-xs-12">
              <PickerWrapper
                className="modalmap"
                onWhatIsHereSelected={(selectedLocation) => selectedLocation && setLocation(selectedLocation)}
              />
            </div>
          </div>
        </div>
      </AccordionTab>
    </Accordion>
    <div className="row u-margin-top">
      <div className="col-xs-12">
        <Button onClick={submit} disabled={!(nameValid && descriptionValid && domainValid)}>
        { createLoading && <Spinner className="u-margin-right-xs">loading...</Spinner> } Bevestigen
        </Button>
        <Button
          emphasis="medium"
          onClick={() => dispatch(closeModal())}>Annuleren</Button>
      </div>
    </div>
  </>

}

export default CreateTask;
